/**
 * 클립보드 복사 기능을 위한 컴포저블
 */
export function useClipboard() {
  /**
   * 텍스트를 클립보드에 복사
   * @param {string} text - 복사할 텍스트
   * @param {Object} options - 옵션
   * @param {boolean} options.showToast - 토스트 메시지 표시 여부
   * @param {string} options.successMessage - 성공 메시지 (기본: '{text} 복사됨')
   */
  const copyToClipboard = async (text, options = {}) => {
    const { showToast = true, successMessage } = options;
    const message = successMessage || `${text} 복사됨`;

    try {
      await navigator.clipboard.writeText(text);
      
      if (showToast) {
        // 커스텀 토스트 이벤트 발생
        const event = new CustomEvent('show-toast', {
          detail: { message, type: 'success' },
        });
        window.dispatchEvent(event);
      }

      return true;
    } catch (err) {
      console.error('클립보드 복사 실패:', err);
      
      // Fallback: 구식 방법
      try {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        const success = document.execCommand('copy');
        document.body.removeChild(textArea);

        if (success && showToast) {
          alert(message);
        }

        return success;
      } catch (fallbackErr) {
        console.error('Fallback 클립보드 복사도 실패:', fallbackErr);
        if (showToast) {
          alert('클립보드 복사에 실패했습니다.');
        }
        return false;
      }
    }
  };

  /**
   * 클립보드에서 텍스트 읽기
   */
  const readFromClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      return text;
    } catch (err) {
      console.error('클립보드 읽기 실패:', err);
      return null;
    }
  };

  /**
   * 클립보드 API 지원 여부 확인
   */
  const isClipboardSupported = () => {
    return navigator.clipboard && window.isSecureContext;
  };

  return {
    copyToClipboard,
    readFromClipboard,
    isClipboardSupported,
  };
} 